import { ref, readonly } from "vue"

const online = ref<boolean>(typeof navigator !== "undefined" ? navigator.onLine : true)
let listenerInstalled = false

export function initOfflineListener(): void {
  if (listenerInstalled || typeof window === "undefined") return
  listenerInstalled = true
  window.addEventListener("online", () => { online.value = true })
  window.addEventListener("offline", () => { online.value = false })
}

export function useOffline() {
  return {
    online: readonly(online),
    isOffline: readonly(ref(!online.value)),
  }
}

/* Exported for tests. */
export function _setOnline(value: boolean): void {
  online.value = value
}
